import React from 'react'
import './certficateCard.css'
import CertficateCard from './certficatescard'
import { certficateCarddata } from './certificatecardData'

const certficates = () => {
  return (
    <div className='work-container'>
        <h1 className='project-heading'> certficates </h1>
        <div className="project-container">
           {certficateCarddata.map((val, index) => {
            return (
                <CertficateCard 
                key={index}
                imgsrc={val.Imgsrc}
                title={val.title}
                text={val.text}
                sources={val.sources}
                />

            )
            })}
        </div>
    </div>
  )
}

export default certficates